import { PageContainer } from "../../components"

export const SingleServerMainPage = ({ server }: { server: any }) => {
  return <PageContainer title={server.id}>{server.id}</PageContainer>
}
